"use strict";
angular.module('manageGroupsModule', ['manageGroupsServiceModule'])
    .controller('manageGroupsCtrl', ['$scope', "$rootScope", "$timeout", "$state", "dateFilter", "commandService", "trsspliceString", "modalDialog", "manageGroupsService", function($scope, $rootScope, $timeout, $state, dateFilter, commandService, trsspliceString, modalDialog, manageGroupsService) {
        var format = "yyyy-MM-dd";
        var vm = $scope.vm = {
            groupStatusOptions: [
                { name: '全部状态', value: '' },
                { name: '启用', value: '0' },
                { name: '停用', value: '-1' }
            ],
            groupStatusOption: { name: '全部状态', value: '' },
            keyword: '',
            groups: [],
            pageparams: {
                PageId: 1,
                PageSize: 20,
            },
            selectAll: false,
            page: {
                PAGESIZE: 20
            },
            jumptoPage: 1,
            groupParams: function() {
                return {
                    PageIndex: this.pageparams.PageId,
                    PageSize: this.pageparams.PageSize,
                    STATUS: this.groupStatusOption.value,
                    GNAME: this.keyword
                }
            }
        };
        $scope.switchBtn = function(group) {
            var confirmInfo = group.status ? "确定停用？" : "确定启用？";
            modalDialog.alertType(confirmInfo, "", "ask", true, function() {
                $rootScope.$broadcast("manaRefreshSummaryGroups");
                group.status = !group.status;
                changeStatusOf(group);

            });
        };
        /** [newCreateGroup description]新建点击弹出弹框 */
        $scope.newCreateGroup = function(group) {
            manageGroupsService.newCreateGroup(group).then(function() {
                refreshList(vm.groupParams());
            });
        };

        function changeStatusOf(group) {
            commandService.newInvoke('changeGroupStatus', { GroupId: group.id, Status: group.status ? 0 : -1 }).then(function(res) {
                if ('true' !== res.ISSUCCESS) {
                    modalDialog.alertType('修改状态失败', '', 'error', false, function() {
                        group.status = !group.status;
                    });
                } else {
                    refreshList(vm.groupParams());
                };
            });
        }
        $scope.switchCheck = function(group) {
            group.checked = !group.checked;
        };
        $scope.checkAllGroup = function(group) {
            vm.selectAll = !vm.selectAll;
            angular.forEach(vm.groups, function(group, index) {
                group.checked = vm.selectAll;
            });
        };
        $scope.deleteGroups = function() {
            var selectedArr = trsspliceString.filter(vm.groups, 'id', 'checked', true);
            if (selectedArr.length == 0) {
                modalDialog.alertType('无选中分组', '', 'warning', false);
            } else {
                modalDialog.alertType('确定删除以下分组吗？', trsspliceString.filter(vm.groups, 'name', 'checked', true).join('\r\n'), 'ask', true, function() {
                    deleteGroupsbyId(selectedArr.join(','));
                    $rootScope.$broadcast("manaRefreshSummaryGroups");
                });
            }
        };
        $scope.deleteGroup = function(group) {
            modalDialog.alertType('确定删除该分组吗？', group.name, 'ask', true, function() {
                deleteGroupsbyId(group.id);
                $rootScope.$broadcast("manaRefreshSummaryGroups");
            });
        };
        /** [selectNum description]: 选择单页显示的数据条数 */
        $scope.selectNum = function() {
            vm.pageparams.PageSize = vm.page.PAGESIZE;
            vm.pageparams.PageId = vm.page.CURRPAGE = 1;
            refreshList(vm.groupParams());
        };
        /** [pageChanged description]点击切换页面 */
        $scope.pageChanged = function() {
            vm.pageparams.PageId = vm.page.CURRPAGE;
            refreshList(vm.groupParams());
        };
        /** [jumpToPage description]指定页面页码的跳转操作 */
        $scope.jumpToPage = function() {
            vm.pageparams.PageId = vm.jumptoPage;
            refreshList(vm.groupParams());
        };
        /** [deleteGroupsbyId description: 删除选题的操作] */
        function deleteGroupsbyId(ids) {
            commandService.newInvoke('delReportGroup', { GroupIds: ids }).then(function(res) {
                if ('true' === res.ISSUCCESS) {
                    $timeout(function() {
                        modalDialog.alertType('删除成功', '', 'success', false, function() {
                            refreshList(vm.pageparams);
                        });
                    }, 1000);
                }
            });
        }

        /** [initList description:] 选择状态时 晚上对该状态下数据的抓取 */
        $scope.initList = function($event) {
            if ($event && $event.keyCode != 13) return;
            vm.pageparams.PageId = 1;
            refreshList(vm.groupParams());
        };
        /** [refreshList description]获取分组数据的操作函数 */
        $scope.refreshList = function() {
            refreshList(vm.groupParams());
        };

        function initPage() {
            refreshList(vm.groupParams());
        }
        /** [refreshList description]获取分组数据的函数全局调用*/
        function refreshList(params) {
            commandService.newInvoke('queryReportGroups', params).then(function(res) {
                vm.groups = res.DATA.map(function(item) {
                    return {
                        id: item.NEWGROUPID,
                        name: item.GNAME,
                        status: item.STATUS == '0',
                        updateTime: item.FLOWVERSIONTIME,
                        checked: false,
                        order: item.SERIALNUMBER
                    }
                });
                vm.page = res.PAGER;
                vm.jumptoPage = vm.page.CURRPAGE;
                if ($scope.vm.groups.length === 0) {
                    $scope.vm.selectAll = false;
                }
            });
        }
        initPage();
    }]);